import { render, staticRenderFns } from "./topVisitorCard.vue?vue&type=template&id=740a7868&"
import script from "./topVisitorCard.vue?vue&type=script&lang=js&"
export * from "./topVisitorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports